export default {
    data() {
        return {
            feature: [{
                title: '数据基座层',
                numberPic: require("../../assets/icons/num1.png"),
                text: '校园管理数据（教师学生考勤、低代码智慧校务系列应用等）、班级管理数据（学生成长画像（综合评价）、班级评价等）、教育教学数据（学科测验成绩、学情分析报告等）、外部适配数据（区域教育政策、安全教育标准等）'
            }, {
                title: 'AI能力层',
                numberPic: require("../../assets/icons/num2.png"),
                text: '智能分析决策模块（基于多维度数据建模，输出可视化分析报告与决策建议）、智能服务交互模块（自然语言交互（语音 / 文字）、多场景智能助手，支持定制化指令）、智能治理预警模块（基于数据阈值与 AI 算法，实现风险预警与智能干预）'
            }, {
                title: '场景应用层',
                numberPic: require("../../assets/icons/num3.png"),
                text: '班级AI助手、管理AI助手、教学研修AI助手、家校AI助手'
            }],
        }
    },
    created() {

    },
}